import { render, staticRenderFns } from "./DocHubResourceDisplay.vue?vue&type=template&id=287fd4ba&scoped=true"
import script from "./DocHubResourceDisplay.vue?vue&type=script&lang=js"
export * from "./DocHubResourceDisplay.vue?vue&type=script&lang=js"
import style0 from "./DocHubResourceDisplay.vue?vue&type=style&index=0&id=287fd4ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287fd4ba",
  null
  
)

export default component.exports